import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import useStyles from './style';

const BlockName: FC<PropsWithChildren> = ({ children }) => {
  const classes = useStyles();

  return <div className={classNames('blockName', classes.blockName)}>{children}</div>;
};

export default BlockName;
